// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_account_sharing_model from "./web_account_sharing_model.js";
import * as Mapre_web__Web_accounts_model from "./web_accounts_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function disabled(p) {
  if (p.loading || p.pending) {
    return true;
  } else {
    return Stdlib__Option.fold(false, Mapre_web__Web_account_sharing_model.busy, p.sharing);
  }
}

function name(p) {
  return Mapre_web__Web_accounts_model.provider_name(p.provider);
}

function provider(source, send) {
  const partial_arg = Stdlib__List.map((function (value) {
    const partial_arg = {
      TAG: /* Accounts */ 41,
      _0: {
        TAG: /* Change */ 2,
        _0: /* Provider */ 2,
        _1: value
      }
    };
    const partial_arg$1 = (function (param) {
      return Lui_elements.press(send, partial_arg, param);
    });
    const partial_arg$2 = Mapre_web__Web_accounts_model.provider_name(value);
    return function (param, param$1) {
      return Lui_elements.menu_item(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    };
  }), {
    hd: "devin",
    tl: {
      hd: "cursor",
      tl: {
        hd: "grok",
        tl: /* [] */ 0
      }
    }
  });
  const partial_arg$1 = "below";
  const partial_arg$2 = function (param, param$1) {
    return Lui_elements.dropdown_menu(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, param, param$1);
  };
  const partial_arg$3 = Signal.map((function (p) {
    return p.provider_menu;
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___001_) {
      const partial_arg = {
        TAG: /* Accounts */ 41,
        _0: /* Close_provider */ 7
      };
      const partial_arg$1 = (function (param) {
        return Lui_elements.press(send, partial_arg, param);
      });
      const partial_arg$2 = {
        TAG: /* Accounts */ 41,
        _0: /* Toggle_provider */ 6
      };
      const partial_arg$3 = (function (param) {
        return Lui_elements.press(send, partial_arg$2, param);
      });
      const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (p) {
        if (disabled(p)) {
          return true;
        } else {
          return p.selected !== undefined;
        }
      }), source)));
      const partial_arg$5 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map(name, source)));
      const partial_arg$6 = "Subscription service";
      return function (param, param$1) {
        return Lui_elements.select(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, partial_arg$5, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$3, partial_arg$2, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$4 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$5 = 0;
  return function (param, param$1) {
    return Lui_elements.stack(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, param, param$1);
  };
}

function login(source) {
  const pending = Signal.map((function (p) {
    return p.login !== undefined;
  }), source);
  const value = function (f, p) {
    return Stdlib__Option.fold("", f, p.login);
  };
  const partial_arg = "Authorization pending";
  const partial_arg$1 = "Finish signing in with the provider, then check the connection here.";
  const partial_arg$2 = "muted";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___002_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (p) {
          return "Open " + (Mapre_web__Web_accounts_model.provider_name(p.provider) + " login");
        }), source)));
        const partial_arg$1 = "blank";
        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (param) {
          return value((function (login) {
            return login.url;
          }), param);
        }), source)));
        return function (param, param$1) {
          return Lui_elements.link(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___003_) {
          const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (param) {
            return value((function (login) {
              return Stdlib__Option.value(login.user_code, "");
            }), param);
          }), source)));
          return function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___004_) {
            const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (param) {
              return value((function (login) {
                return "Expires: " + new Date(login.expires_at).toISOString();
              }), param);
            }), source)));
            const partial_arg$1 = "muted";
            return function (param, param$1) {
              return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          }),
          tl: /* [] */ 0
        }
      }
    }
  };
  const partial_arg$3 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$4 = 0;
  const partial_arg$5 = 6;
  const partial_arg$6 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, param, param$1);
  };
  return function (param, param$1) {
    return Lui_elements.if_(pending, partial_arg$6, param, param$1);
  };
}

function view(source, send) {
  const label = function (p) {
    return Mapre_web__Web_accounts_model.provider_name(p.provider) + " account label";
  };
  const partial_arg = Signal.map((function (p) {
    return p.provider;
  }), source);
  const partial_arg$1 = "Devin personal access token";
  const partial_arg$2 = "muted";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___007_) {
        const partial_arg = (function (param) {
          return Lui_elements.on_input(send, (function (value) {
            return {
              TAG: /* Accounts */ 41,
              _0: {
                TAG: /* Change */ 2,
                _0: /* Pat */ 1,
                _1: value
              }
            };
          }), param);
        });
        const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map(disabled, source)));
        const partial_arg$2 = "Devin personal access token";
        const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (p) {
          return p.pat;
        }), source)));
        return function (param, param$1) {
          return Lui_elements.secure_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$3 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$4 = 6;
  const partial_arg$5 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, param, param$1);
  };
  const partial_arg$6 = Signal.map((function (p) {
    return p.provider === "devin";
  }), source);
  const partial_arg_0$1 = provider(source, send);
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___005_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map(label, source)));
        const partial_arg$1 = "muted";
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.dyn(undefined, (function (service) {
          return function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___006_) {
              const partial_arg = (function (param) {
                return Lui_elements.on_input(send, (function (value) {
                  return {
                    TAG: /* Accounts */ 41,
                    _0: {
                      TAG: /* Change */ 2,
                      _0: /* Label */ 0,
                      _1: value
                    }
                  };
                }), param);
              });
              const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (p) {
                if (disabled(p)) {
                  return true;
                } else {
                  return p.selected !== undefined;
                }
              }), source)));
              const partial_arg$2 = Mapre_web__Web_accounts_model.provider_name(service) + " account label";
              const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (p) {
                return p.label;
              }), source)));
              return function (param, param$1) {
                return Lui_elements.text_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param, param$1);
          };
        }), partial_arg, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$6, partial_arg$5, param, param$1);
        }),
        tl: {
          hd: login(source),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.scoped((function (__lui_context___008_) {
                const partial_arg = {
                  TAG: /* Accounts */ 41,
                  _0: /* Submit */ 4
                };
                const partial_arg$1 = (function (param) {
                  return Lui_elements.press(send, partial_arg, param);
                });
                const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___008_.ui_scope, Signal.map((function (p) {
                  return !Mapre_web__Web_accounts_model.can_save(p);
                }), source)));
                const partial_arg$3 = "primary";
                const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___008_.ui_scope, Signal.map((function (p) {
                  if (p.login !== undefined) {
                    return "Check connection";
                  } else {
                    return "Connect " + Mapre_web__Web_accounts_model.provider_name(p.provider);
                  }
                }), source)));
                return function (param, param$1) {
                  return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                };
              }), param, param$1);
            }),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.scoped((function (__lui_context___009_) {
                  const partial_arg = {
                    TAG: /* Accounts */ 41,
                    _0: /* Fresh */ 3
                  };
                  const partial_arg$1 = (function (param) {
                    return Lui_elements.press(send, partial_arg, param);
                  });
                  const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___009_.ui_scope, Signal.map(disabled, source)));
                  const partial_arg$3 = "ghost";
                  const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___009_.ui_scope, Signal.map((function (p) {
                    return "Add " + (Mapre_web__Web_accounts_model.provider_name(p.provider) + " account");
                  }), source)));
                  return function (param, param$1) {
                    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                }), param, param$1);
              }),
              tl: /* [] */ 0
            }
          }
        }
      }
    }
  };
  const partial_arg$7 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$8 = 0;
  const partial_arg$9 = 6;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
